import React, { useEffect } from 'react'

import { Box } from '@material-ui/core'
import { isEmpty } from 'lodash'

import { GreenHighlighted, LoadingFeedback } from 'components'
import { Text } from '../'

import useTrailStep from 'hooks/useTrailStep'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'

const DocumentInfo = () => {
  const { privacyPolicy, setPrivacyPolicy } = useTrailStep()

  const { response, isLoading } = useFetch(
    service.dponet.privacyPolicies.get,
    {
      category: constants.documents.PRIVACY_POLICY_CATEGORY_ID,
      order: ['public_document DESC', 'updated_at DESC'],
    },
    [],
    isEmpty(privacyPolicy),
  )

  useEffect(() => {
    if (!response) return

    setPrivacyPolicy(response?.data?.privacyPolicies[0] || null)
  }, [response])

  return (
    <>
      <LoadingFeedback loading={isLoading} />
      <Text color="primary" fontSize="7vh" variant="h1">
        Documentos
      </Text>
      <Box my={3}>
        <Text fontSize="3.2vh" variant="h4" gutterBottom>
          Dentre os documentos exigidos pela lei, podemos destacar um deles:
        </Text>
      </Box>
      <Text fontSize="3.2vh" variant="h4" gutterBottom>
        <GreenHighlighted>Aviso de Privacidade</GreenHighlighted>
      </Text>
      {isEmpty(privacyPolicy) ? (
        <Box my={3}>
          <Text fontSize="3.2vh" variant="h4" gutterBottom>
            Para facilitar o cumprimento dessa obrigação de forma simples e
            rápida, este documento será gerado automaticamente para você. Basta
            revisá-lo e ajustá-lo conforme a realidade da sua organização.
          </Text>
        </Box>
      ) : (
        <Box my={3}>
          <Text fontSize="3.2vh" variant="h4" gutterBottom>
            Um documento de Aviso de Privacidade foi criado anteriormente, para
            acessá-lo vá ao menu "Documentos".
          </Text>
        </Box>
      )}
    </>
  )
}

export default DocumentInfo
